<script setup lang="ts">
import { useMeta } from '@/composables/useMeta';
import type { LinkPageHost } from '@/modules/link-page/domain/entities/LinkPage';
import { buildLinkPageMeta } from '@/modules/seo/metadata';
import PublicLinkPageView from './PublicLinkPageView.vue';

const props = defineProps<LinkPageHost>();
useMeta(buildLinkPageMeta(props.siteOrigin, props.address, props.result));
</script>

<template>
  <PublicLinkPageView :result="result" :site-origin="siteOrigin" />
</template>
